import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import cn from 'classnames';

import { questionarySteps } from '../../constants/questioner';
import { setStepsData } from '../../actions/steps';

import styles from './ProgressBar.module.css';

const ProgressBar = (props) => {

  const { stepsData, setStepsData } = props;

  const percent = (stepsData.step - 1) / (questionarySteps[0].step - 1) * 100;
  console.log('===percent', percent, stepsData.step);

  const prevStep = () => {
    stepsData.step--;
    setStepsData({ ...stepsData });
  };

  return (
    <div className={cn(styles.wrapper, 'progress-bar-wrapper')}>
      <Link className={styles.logo} to="/" />
      <div className={styles.backButton} onClick={prevStep} />
      <progress
        max="100"
        value={percent}
        className={cn(styles.progress, 'progress-bar')}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  stepsData: state.steps.stepsData,
});

const mapDispatchToProps = {
  setStepsData,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProgressBar);
